module.exports = __webpack_public_path__ + "static/media/settings_512.dbdb79a9.png";